// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2gT6h","row":"styles_row__2HTCc"};